import { render, staticRenderFns } from "./CampaignPublic.vue?vue&type=template&id=96ef24b2&"
import script from "./CampaignPublic.vue?vue&type=script&lang=js&"
export * from "./CampaignPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports